import React from "react";
import LaundryBoxTable from "components/Tables/LaundryBox/LaundryBox";

const ListlaundryBox = () => {
  return (
    <div>

      <LaundryBoxTable />
    </div>
  );
};

export default ListlaundryBox;
